import { useEffect, useState } from 'react';

import { getPaymentLinkById } from '@/services/api';
import { useParams } from 'react-router-dom';
import { useAsyncFn } from 'react-use';

import { ILinkProps } from '@/pages/Checkout/types/paymentLinkContextTypes';

const useGetPaymentLink = () => {
  const { id } = useParams();

  const [getLinkIsLoading, setGetLinkIsLoading] = useState<boolean>(true);
  const [getLinkData, setGetLinkData] = useState<ILinkProps | null>(null);

  const [paymentLinkData, paymentLinkRequest] = useAsyncFn(getPaymentLinkById);

  useEffect(() => {
    paymentLinkRequest(id && id.split(' ')[0]);
  }, []);

  useEffect(() => {
    if (paymentLinkData.loading) return;

    if (paymentLinkData.value?.data) {
      setGetLinkData(paymentLinkData.value?.data?.data);
      setGetLinkIsLoading(false);
    }
  }, [paymentLinkData]);

  return {
    getLinkIsLoading,
    getLinkData,
    getLinkError: paymentLinkData.error,
  };
};

export default useGetPaymentLink;
